import { logEvent } from "firebase/analytics";
import { getFirebaseAnalytics } from "./firebase";

export const trackChatModeSwitch = (mode: "chat" | "search" | "ideas" | "files" | "gebreken") => {
  const analytics = getFirebaseAnalytics();
  if (analytics) {
    logEvent(analytics, "chat_mode_switch", {
      mode,
    });
  }
};
